import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';

/**
 * Ein Bild formatfuellend ueber der Seite, bis es weggeklickt wird.
 *
 * <p>Der Aufrufer haelt die URL und blendet die Komponente ueber {@code @if} ein; sie
 * selbst kennt weder Herkunft noch Lebensdauer des Bildes. Wer eine Blob-URL
 * hineingibt, gibt sie auch selbst wieder frei.
 *
 * <p>Von aussen kommt nur, <em>was</em> das Bild zeigt. Was der Klick <em>tut</em>,
 * weiss die Komponente selbst und beschriftet es auch selbst — sonst muesste jede
 * Aufrufstelle denselben Schliessen-Text noch einmal uebersetzen.
 *
 * <p>Die Flaeche nimmt den Fokus, solange sie offen ist. Ohne das stuende er weiter auf
 * der Schaltflaeche dahinter, jeder Tastendruck stiege von dort auf und ESC erreichte
 * das Overlay nie. Wohin der Fokus danach zurueckgeht, entscheidet der Aufrufer.
 *
 * <p>Zusammengezogen aus zwei gleichen Umsetzungen — Referenzbild am Testschritt und
 * Anhang an einem Testlauf-Kommentar —, damit Rolle, Tastaturbedienung und
 * Beschriftung nicht an zwei Stellen gepflegt werden muessen.
 */
@Component({
  selector: 'app-image-lightbox',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, A11yModule],
  templateUrl: './image-lightbox.component.html',
  styleUrl: './image-lightbox.component.scss',
})
export class ImageLightboxComponent {
  readonly url = input.required<string>();

  /** Bereits uebersetzt: Alternativtext des Bildes, nicht die Beschriftung der Flaeche. */
  readonly alt = input.required<string>();

  readonly closed = output<void>();
}
